"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Clear a cached object by its key from an event object
 * @param event The event object
 * @param key The cache key
 */
function clearEventDataCache(event, key) {
    if (event && event.eventDataCache && event.eventDataCache.hasOwnProperty(key)) {
        delete event.eventDataCache[key];
    }
}
exports.default = clearEventDataCache;
//# sourceMappingURL=clearEventDataCache.js.map